
import AppLayout from '@/components/layout/AppLayout';
import AdelantosPanel from '@/components/adelantos/AdelantosPanel';
import AcquirerGate from '@/components/adelantos/AcquirerGate';
import { useActivation } from '@/contexts/ActivationContext';

function AdelantosContent() {
  const { isStepComplete, isLoading } = useActivation();

  if (isLoading) {
    return (
      <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl shadow-sm p-12 flex items-center justify-center">
        <span className="material-symbols-outlined text-3xl text-slate-300 animate-spin">progress_activity</span>
      </div>
    );
  }

  const hasAcquirer = isStepComplete('credencialesAdquirente');

  if (!hasAcquirer) {
    return (
      <div className="flex flex-col flex-1 items-center justify-center min-h-[calc(100vh-theme(spacing.20)-theme(spacing.24))]">
        <div className="w-full max-w-5xl mx-auto">
          <AcquirerGate />
        </div>
      </div>
    );
  }

  return <AdelantosPanel activeTab="cuotas" />;
}

export default function CuotasPage() {
  return (
    <AppLayout wide>
      <AdelantosContent />
    </AppLayout>
  );
}
